import { IValidationErrorResponse } from "app/modules/tp/_apiResponse"
import { createErrorMessage } from "../Alert";

export const ValidationError = ({error}:{error: IValidationErrorResponse}) => (
    createErrorMessage("Errore di validazione", "Ricontrolla i campi",
    <ul>
        {
            Object.entries(error.data).map(([key, value]) => (
                (Array.isArray(value) && value.length > 0) ?
                    <li key={key}>{value.join(". ")}</li> :
                    <></>
            ))
        }
    </ul>
    )
)

export default ValidationError;
